import React, { useState, useRef, useEffect } from 'react';
import styles from './linkPrev.css';
import { useForceUpdate } from '../../../../utils/func';

const LinkPrev = () => {
    const [ url, setUrl ] = useState( '' );
    let frame = useRef();
    const forceUpdate = useForceUpdate();


    const getQuizNumber = () => {
        let guizId = window.location.href.split( '/' );
        for ( let i = 0 ; i < guizId.length ; i++ ) {
            if ( guizId[ i ] === 'quiz' ) {
                return guizId[ i + 1 ];
            }
        }
    };

    useEffect( () => {
        setUrl( getFrimeLink() );
        forceUpdate();
    }, [] );


    const getFrimeLink = () => {
        return `${ window.location.origin }/player/quiz/${ getQuizNumber() }/`;
    };


    return (
        <div className={ styles.prewievWrap }>

            <iframe id='prevEmbedFrame-1' ref={ ( elm ) => {
                frame = elm;
            } }
                    src={ url }
                    className={ styles.prevFrame }>Loading..
            </iframe>
        </div>
    );

};
export default LinkPrev;